import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Sales.ContractRefund.Cancel.IParams;
type Request = Api.Sales.ContractRefund.Cancel.IRequest;
type Response = Api.Sales.ContractRefund.Cancel.IResponse;
type Headers = Api.Sales.ContractRefund.Cancel.IHeaders;
const url = '/api/Sales/ContractRefund/Cancel/:id';
export default async function contractRefundCancelApi({ id, ...body }: Params & Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id }, null),
    body,
    headers: getDefaultHeaders(),
  });
}
